/*
 * ************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *   Copyright 2021 Adobe Systems Incorporated
 *   All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 * ************************************************************************
 */

import * as R from 'ramda';
import { takeLatest, put, select } from 'redux-saga/effects';
import { UPDATE_SETTINGS_VALIDATION } from '../actions';
import { selectUpdatedSettingsValidation } from '../selectors';
import {
  newSettingsValidation
} from '../data/prefabs';

const handleUpdateSettingsValidation = function* ({ payload: { namespace, setting, value } }) {
  const newSettingsValue = yield select(selectUpdatedSettingsValidation);
  const updates = setting === 'arguments' && !value ? R.dissocPath([namespace, setting], newSettingsValue)
    : R.assocPath([namespace, setting], value, newSettingsValue);
  yield put(newSettingsValidation.changeAction(updates));
};

export default function* watchUpdateSettingsValidation() {
  yield takeLatest(UPDATE_SETTINGS_VALIDATION, handleUpdateSettingsValidation);
}
